__webpack_require__.p = "https://dashboard.class.talent-lnr.ru/";